import React, { useEffect } from "react";
import { X } from "lucide-react";
import { GALLERY } from "@/constants/testIds";

export default function ArtworkLightbox({ art, onClose, onReserve }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      data-testid={GALLERY.lightbox}
      className="fixed inset-0 z-[100] fade-in"
      style={{
        background: "rgba(6, 10, 8, 0.88)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
      }}
      onClick={onClose}
    >
      <button
        data-testid={GALLERY.lightboxClose}
        aria-label="Close"
        onClick={onClose}
        className="absolute top-5 right-5 z-10 w-10 h-10 flex items-center justify-center text-ivory hover:text-[#D4AF37] transition-colors"
        style={{ color: "var(--ivory)" }}
      >
        <X size={22} strokeWidth={1.5} />
      </button>

      <div
        className="w-full h-full flex flex-col items-center justify-center p-6 md:p-14"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={art.image_url}
          alt={art.title}
          className="max-h-[75vh] max-w-[90vw] object-contain shadow-2xl fade-in"
        />
        <div className="mt-6 text-center text-ivory" style={{ color: "var(--ivory)" }}>
          <h3 className="font-serif text-3xl tracking-tight">{art.title}</h3>
          {art.subtitle && (
            <div className="mt-1 font-serif italic text-sm opacity-70">
              {art.subtitle}
            </div>
          )}
          <div className="mt-2 text-[11px] tracking-[0.3em] uppercase opacity-60">
            {[art.medium, art.dimensions, art.year].filter(Boolean).join(" · ")}
          </div>
          <button
            onClick={onReserve}
            className="mt-6 btn-gold px-8 h-12 tracking-[0.25em] text-[11px] uppercase font-medium"
          >
            Inquire / Reserve
          </button>
        </div>
      </div>
    </div>
  );
}
